var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "780px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("remove_red_eye")]),
              _vm._v(" Parametros programación de vacación\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "pt-0" },
                [
                  _c(
                    "v-container",
                    { staticClass: "pt-0", attrs: { "grid-list-md": "" } },
                    [
                      _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                        _c("p", { staticClass: "titulo" }, [
                          _vm._v("Gestión :")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "texto" }, [
                          _vm._v(_vm._s(this.form.gestion) + " ")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("p", { staticClass: "titulo" }, [
                            _vm._v("Fecha inicio:")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "texto" }, [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$moment(_vm.form.fecha_inicio)
                                  .format("DD/MM/YYYY")
                              ) + " "
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-spacer")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                        _c("p", { staticClass: "titulo" }, [
                          _vm._v("Fecha finalización:")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "texto" }, [
                          _vm._v(
                            _vm._s(
                              _vm
                                .$moment(_vm.form.fecha_fin)
                                .format("DD/MM/YYYY")
                            ) + " "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      this.form.fecha_corte
                        ? _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                            _c("p", { staticClass: "titulo" }, [
                              _vm._v("Porcentage de programación:")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "texto" }, [
                              _vm._v(_vm._s(this.form.porcentaje) + " % ")
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      this.form.fecha_ampliacion
                        ? _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                            _c("p", { staticClass: "titulo" }, [
                              _vm._v("Fecha ampliación:")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "texto" }, [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$moment(_vm.form.fecha_ampliacion)
                                    .format("DD/MM/YYYY")
                                ) + " "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      this.form.fecha_corte
                        ? _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                            _c("p", { staticClass: "titulo" }, [
                              _vm._v("Fecha corte:")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "texto" }, [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$moment(_vm.form.fecha_corte)
                                    .format("DD/MM/YYYY")
                                ) + " "
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "pr-4" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(" ACEPTAR\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d2dbc34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d2dbc34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/parametros_vacacion/dialogs/VerParametro.vue
// module id = null
// module chunks = 